import styled, { css } from 'styled-components'
// libs
import { isMobileOnly } from 'react-device-detect'
// components
import { Scrollbar } from 'components/UI'
// themes
import colors from 'themes/colors'
// utils
import { darken, ellipsis } from 'polished'
// constants
import { APP_BAR_HEIGHT } from 'constants/layout'
// icons
import AddIconOrigin from '@mui/icons-material/Add'

const ButtonLink = styled.span`
  align-items: center;
  color: ${colors.blue300};
  cursor: pointer;
  display: flex;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  width: 100%;
  height: 44px;

  &:hover {
    color: ${darken(0.1, colors.blue300)};
  }
`
const AddIcon = styled(AddIconOrigin)`
  color: ${colors.blue300};
  font-size: 14px;
`

const SectionHeader = styled.div`
  background: ${colors.white100};
  position: sticky;
  top: 0;

  h2 {
    margin-bottom: 0;
    user-select: none;
  }
`

const Sidebar = styled(Scrollbar)<{ $isViewSelected: boolean }>`
  margin-right: 12px;
  max-width: 15%;
  width: 100%;
  overflow: hidden;

  a {
    text-decoration: none;
    color: ${colors.blue300};

    &:hover,
    &:active,
    &:focus,
    &:visited {
      text-decoration: none;
      color: ${colors.blue300};
    }
  }

  ${SectionHeader}:first-child h2 {
    margin-top: 0;
  }

  @media (max-width: 768px) {
    padding: 16px;
    max-width: 100%;
    display: ${({ $isViewSelected }) => ($isViewSelected ? 'none' : 'block')};
  }
`

const RiskViewLabel = styled.div<{ $isActive: boolean }>`
  ${ellipsis('90%')};

  color: ${colors.blue300};
  cursor: pointer;
  display: block;
  font-size: 15px;
  font-weight: ${({ $isActive }) => ($isActive ? 700 : 500)};

  &:hover {
    color: ${darken(0.1, colors.blue300)};
  }
`

const RiskTemplateLabel = styled.div`
  align-items: center;
  display: flex;
  padding-right: 16px;
  white-space: nowrap;

  a {
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      color: ${darken(0.1, colors.blue300)};
    }
  }
`

const Content = styled.div`
  display: flex;
  height: 100%;

  ${isMobileOnly &&
  css`
    max-height: calc(100dvh - ${APP_BAR_HEIGHT}px);
  `}
`

export { ButtonLink, AddIcon, Sidebar, RiskViewLabel, RiskTemplateLabel, Content, SectionHeader }
